/**
 * Create store system patch management -prismPatch
 *
 * @since 2018-11-01
 * @author devp018
 * @modify jupil.Go <devp018>
 */

import {getCodeJsonRow} from '~/utils/device-common'
import {SystemApiPrefix as smApiPrefix} from 'utils'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // history
    patchHistory: `${smApiPrefix}/patch/histories`,
    // update-server list
    updateServer: `${smApiPrefix}/patch/server`,
    // current version
    currVersion: `${smApiPrefix}/patch/current-version`,
    // last version
    lastVersion: `${smApiPrefix}/patch/latest-version`,
    // release note
    releaseNote: `${smApiPrefix}/patch/release-note`,
    // patch file( userid, userpasswd )
    patchFileExecute: `${smApiPrefix}/patch/execute/file`,
    // patch online
    patchOnlineExecute: `${smApiPrefix}/patch/execute/online`,
    // patch note
    detailLog: `${smApiPrefix}/patch/detail-log`
  },
  patchResultOptions: [],
  // config
  patchHistoryInfo: {
    version: '', // version info(string)
    date: '', //    update-date(string)
    result: '', //  (one of succ, fail)
    reason: '' //   detail-result of update
  },
  patchHistoryInfoList: [],
  patchServerInfo: {
    url: '' // url of update-server(https://...)
  },
  patchCurrentVersion: {
    version: ''
  },
  patchLastVersionList: [],
  patchExecuteResult: [],
  patchExecuteParam: {
    path: '', //        fileName of uploaded( call-> https://{url}/api/co/file/import)
    user_id: '', //     required (string - maxLength: 32)
    user_passwd: '', //  required (string - maxLength: 32) - base64
    setParamResult: '',
    original_file: '',
    task_id: '',
    patch_id: null,
    version: ''
  },
  errorMessage: null
})

export const mutations = {
  setErrorMessage (state, data) {
    state.errorMessage = data.msg
    const msg = {
      error: data.msg
    }
    state.errorMessage = msg
  },
  getPatchResultTypeCodeOptions (state) {
    state.patchResultOptions = _.map(getCodeJsonRow('patch_result_type'), (item) => { // 패치 결과
      return { value: item.key, label: item.val }
    })
  },
  resetPatchHistoryInfoList (state) {
    state.patchHistoryInfoList = []
  },
  setPatchHistoryInfoList (state, data) {
    state.patchHistoryInfoList = data
  },
  resetPatchExecuteParam (state, loginId) {
    state.patchExecuteParam.path = ''
    state.patchExecuteParam.user_id = loginId
    state.patchExecuteParam.user_passwd = ''
    state.patchExecuteParam.setParamResult = ''
    state.patchExecuteParam.original_file = ''
    state.patchExecuteParam.task_id = ''
    state.patchExecuteParam.patch_id = null
    state.patchExecuteParam.version = ''
  },
  setPatchExecuteParam (state, item) {
    state.patchExecuteParam.setParamResult = item.status
    state.patchExecuteParam.task_id = item.id
    state.patchExecuteParam.patch_id = item.patch_id
  },
  resetCurrVersionInfo (state) {
    state.patchCurrentVersion.version = ''
  },
  setCurrVersionInfo (state, item) {
    state.patchCurrentVersion.version = item.version
  },
  resetLastVersionInfo (state) {
    state.patchLastVersionList = []
  },
  setLastVersionInfo (state, items) {
    state.patchLastVersionList = items
  },
  resetPatchServerInfo (state) {
    state.patchServerInfo.url = ''
  },
  setPatchServerInfo (state, item) {
    state.patchServerInfo.url = item.url
  },
  resetPatchExecuteResult (state) {
    state.patchExecuteResult = []
  },
  // setPatchExecuteResult (state, data) {
  //   state.patchExecuteResult = data
  // },
  addPatchExecuteResult (state, data) {
    if (data.attributes.logs !== undefined) {
      state.patchExecuteResult = data.attributes.logs
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  async getPatchHistoryInfoList ({commit, state}) {
    commit('resetPatchHistoryInfoList')
    const apiUrl = state.apiUrlPath['patchHistory']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setPatchHistoryInfoList', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getPatchCurrVersionInfo  ({commit, state}) {
    commit('resetCurrVersionInfo')
    const apiUrl = state.apiUrlPath['currVersion']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setCurrVersionInfo', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getPatchLastVersionInfo  ({commit, state}) {
    commit('resetLastVersionInfo')
    try {
      const apiUrl = state.apiUrlPath['lastVersion']
      const {code, result} = await this.$axios.$get(apiUrl)
      if (code !== undefined && (code).toLowerCase() === 'ok') {
        commit('setLastVersionInfo', result)
        return true
      }
      commit('setErrorMessage', result)
      return false
    } catch (e) {
      return false
    }
  },
  async getPatchServerInfo  ({commit, state}) {
    commit('resetPatchServerInfo')
    const apiUrl = state.apiUrlPath['updateServer']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setPatchServerInfo', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async setPatchServerInfo  ({commit, state}) {
    const apiUrl = state.apiUrlPath['updateServer']
    const {code, result} = await this.$axios.$put(apiUrl, {url: state.patchServerInfo.url})
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setPatchServerInfo', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async patchExecuteFile ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['patchFileExecute']
    const postParam = _.cloneDeep(state.patchExecuteParam)
    delete postParam.setParamResult
    delete postParam.version
    delete postParam.user_id
    delete postParam.task_id
    delete postParam.patch_id
    postParam.user_passwd = btoa(postParam.user_passwd)
    loadingOpt.ignoreHaPrefix = false // TAMS
    const {code, result} = await this.$axios.$post(apiUrl, postParam, loadingOpt)
    if (code !== undefined && (code.toLowerCase() === 'ok' || code.toLowerCase() === 'async')) {
      commit('setPatchExecuteParam', result)
      // commit common isChanage
      // this.dispatch(`common/common/setIsChanged`, true)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async patchExecuteOnline ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['patchOnlineExecute']
    const postParam = _.cloneDeep(state.patchExecuteParam)
    delete postParam.path
    delete postParam.setParamResult
    postParam.user_passwd = btoa(postParam.user_passwd)
    loadingOpt.ignoreHaPrefix = false // TAMS
    const {code, result} = await this.$axios.$post(apiUrl, postParam, loadingOpt)
    if (code !== undefined && (code.toLowerCase() === 'ok' || code.toLowerCase() === 'async')) {
      commit('setPatchExecuteParam', result)
      // commit common isChanage
      // this.dispatch(`common/common/setIsChanged`, true)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getPatchFileExecuteResult ({commit, state}, param) {
    const apiUrl = `${state.apiUrlPath['patchFileExecute']}/${param.taskId}/${param.patchId}`
    const {code, result} = await this.$axios.$get(apiUrl, {loading: false, loadingShow: false})
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      if ((result.status).toLowerCase() !== 'ready') {
        commit('addPatchExecuteResult', result)
      }
      result.code = 'ok'
    } else {
      result.code = 'nok'
    }
    return result
  },
  async getPatchOnlineExecuteResult ({commit, state}, param) {
    const apiUrl = `${state.apiUrlPath['patchOnlineExecute']}/${param.taskId}/${param.patchId}`
    const {code, result} = await this.$axios.$get(apiUrl, {loading: false, loadingShow: false})
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      if ((result.status).toLowerCase() !== 'ready') {
        commit('addPatchExecuteResult', result)
      }
      result.code = 'ok'
    } else {
      result.code = 'nok'
    }
    return result
  },
  async setFinishUpdateStatus () {
    // commit common isChanage
    await this.dispatch(`common/common/setIsChanged`, false)
  },
  async getReleaseNoteExport ({commit, state}, param) {
    const apiUrl = `${state.apiUrlPath['releaseNote']}/${param.version}`
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      return result.contents
    }
    commit('setErrorMessage', result)
    return false
  },
  async getDetailLogExport ({commit, state}, param) {
    const apiUrl = `${state.apiUrlPath['detailLog']}/${param.id}/${param.version}`
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      return result.contents
    }
    commit('setErrorMessage', result)
    return false
  }
}

export const getters = {
}

export const strict = false
